<template>
  <div>
    <Header />
    <div class="pt80">
      <div id="section1">
        <div class="container">
          <div class="th">
            <span> {{ $t("header.nav2") }}</span>
            <i class="el-icon-arrow-right"></i>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="th2">{{ $t("pay.th") }}</div>
          <div class="txt">{{ $t("pay.tit") }}</div>
        </div>
      </div>

      <div id="section2">
        <div class="container">
          <div class="list d-flex">
            <div class="item" v-for="i in 5">
              <svgIcon className="icon" :iconName="`icon-pay${i}`"></svgIcon>
              <div>
                <div class="th2">{{ $t(`pay.sec1.t${i}`) }}</div>
                <div class="tips">
                  {{ $t(`pay.sec1.tips${i}`) }}
                </div>
              </div>
            </div>
          </div>
          <img
            src="@/assets/payment-1.png"
            width="707px"
            style="margin: 0 auto; display: block; height: 100%"
          />
        </div>
      </div>

      <div id="section3">
        <div class="container">
          <div class="d-flex">
            <div style="flex: 1">
              <div class="count">187</div>
              <div class="name">{{ $t(`pay.sec2.t1`) }}</div>
            </div>
            <div style="flex: 1">
              <div class="count">3.7B</div>
              <div class="name">{{ $t(`pay.sec2.t2`) }}</div>
            </div>
            <div style="flex: 1">
              <div class="count">469M</div>
              <div class="name">{{ $t(`pay.sec2.t3`) }}</div>
            </div>
            <div style="flex: 1">
              <div class="count">510K</div>
              <div class="name">{{ $t(`pay.sec2.t4`) }}</div>
            </div>
          </div>
        </div>
      </div>

      <div id="section4">
        <div class="container">
          <div class="box">
            <div class="subtit">{{ $t("pay.africa") }}</div>
            <div class="box-content">
              <div
                v-for="(a, index) in country.africa"
                :key="index"
                class="txt"
              >
                {{ a }}
              </div>
            </div>
          </div>
          <div class="box">
            <div class="subtit">{{ $t("pay.asia") }}</div>
            <div class="box-content">
              <div v-for="(a, index) in country.asia" :key="index" class="txt">
                {{ a }}
              </div>
            </div>
          </div>
          <div class="box">
            <div class="subtit">{{ $t("pay.europe") }}</div>
            <div class="box-content">
              <div
                v-for="(a, index) in country.europe"
                :key="index"
                class="txt"
              >
                {{ a }}
              </div>
            </div>
          </div>
          <div class="d-flex last-box">
            <div class="box" style="width: 600px">
              <div class="subtit">{{ $t("pay.latin") }}</div>
              <div class="box-content">
                <div
                  v-for="(a, index) in country.latin"
                  :key="index"
                  class="txt"
                >
                  {{ a }}
                </div>
              </div>
            </div>
            <div style="width: 380px; margin-left: 20px">
              <div class="box">
                <div class="subtit">{{ $t("pay.north") }}</div>
                <div class="box-content" style="padding: 10px 0 10px 24px">
                  <div
                    v-for="(a, index) in country.north"
                    :key="index"
                    class="txt"
                  >
                    {{ a }}
                  </div>
                </div>
              </div>
              <div class="box" style="margin-top: 20px">
                <div class="subtit">{{ $t("pay.oceania") }}</div>
                <div class="box-content" style="padding: 10px 0 10px 24px">
                  <div
                    v-for="(a, index) in country.oceania"
                    :key="index"
                    class="txt"
                    style="width: 88px"
                  >
                    {{ a }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import country from "./country.js";
export default {
  name: "personal",
  components: { Header, Footer },
  data() {
    return {
      activeId: "#section",
      channel: this.$route.query.channel,
      httpIp: "https://naps.zxszkj.com",
      carouselIndex: 0,
      partId: "1",
      addresssId: "a1",
    };
  },
  computed: {
    country() {
      let key = this.$i18n.locale;
      return country[key];
    },
  },
  mounted() {
    localStorage.setItem("channel", this.$route.query.channel);
  },
  methods: {
    toProduct() {
      this.$router.push("/product");
    },
    openAbout() {
      window.open(`${this.httpIp}/#/about`);
    },
    openLogin() {
      this.$router.push("/login");
    },

    changeCarousel(index) {
      console.log(index);
      this.carouselIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
.pt80 {
  padding-top: 80px;
}
.container {
  padding: 0;
}
#section1 {
  height: 203px;
  background-image: url(~@/assets/acq-1.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  .container {
    position: relative;
  }
  .th {
    margin-top: 18px;
    font-weight: 500;
    font-size: 20px;
    color: #3b3b3b;
    line-height: 20px;
    i {
      &:last-child {
        margin-left: -20px;
      }
    }
  }
  .th2 {
    margin-top: 11px;
    margin-bottom: 11px;
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 64px;
  }
  .txt {
    font-weight: 350;
    font-size: 16px;
    color: #000000;
    line-height: 28px;
  }
}

#section2 {
  padding: 50px 0;
  .list {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 50%;
      display: flex;
      height: 110px;
      .icon {
        font-size: 46px;
        margin-right: 17px;
      }
      .th2 {
        font-weight: 700;
        font-size: 18px;
        color: #000000;
        line-height: 22px;
      }
      .tips {
        margin-top: 9px;
        width: 388px;
        font-weight: 350;
        font-size: 14px;
        color: #9e9e9e;
        line-height: 21px;
      }
    }
  }
  .content {
    position: relative;
    padding-top: 163px;
    padding-left: 29px;
    .th2 {
      font-weight: 300;
      font-size: 42px;
      color: #1485ef;
      line-height: 51px;
    }
    .th3 {
      font-weight: 300;
      font-size: 42px;
      line-height: 51px;
      color: #000000;
    }
    .btn {
      margin-top: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 169px;
      height: 54px;
      background: linear-gradient(270deg, #1485ef 0%, #1485ef 100%);
      border-radius: 30px;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      span {
        margin-right: 10px;
      }
    }
    .pic {
      position: absolute;
      top: -100px;
      left: 140px;
    }
  }
}
#section3 {
  .count {
    font-weight: 900;
    font-size: 90px;
    color: #1485ef;
    line-height: 135px;
  }
  .name {
    font-weight: 400;
    font-size: 30px;
    color: #9e9e9e;
    line-height: 45px;
  }
}
#section4 {
  margin-top: 44px;
  margin-bottom: 78px;
  .box {
    margin-bottom: 20px;
    border: 1px solid #1485ef;
    border-radius: 20px;
    overflow: hidden;
    .subtit {
      padding-left: 37px;
      background: #1485ef;
      color: #fff;
      height: 46px;
      font-weight: 500;
      font-size: 30px;
      color: #ffffff;
      line-height: 46px;
    }
    .box-content {
      padding: 20px 0 20px 40px;
      display: flex;
      flex-wrap: wrap;
      .txt {
        width: 130px;
        font-weight: 500;
        font-size: 16px;
        color: #9e9e9e;
        line-height: 29px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/payment.vue